import type { ReactElement } from 'react';
import { Link } from 'react-router';

export function NotFoundPage(): ReactElement {
  return (
    <main className="mx-auto flex min-h-screen max-w-6xl flex-col items-center justify-center gap-4 px-6 text-center">
      <span className="font-mono text-[11px] text-muted-foreground uppercase tracking-[0.12em]">
        404
      </span>
      <h1 className="text-2xl font-bold tracking-[-0.04em]">찾으시는 페이지가 없습니다</h1>
      <p className="text-[15px] text-muted-foreground">
        주소가 바뀌었거나 삭제된 페이지일 수 있습니다.
      </p>
      <Link
        to="/"
        className="mt-2 inline-flex h-10 items-center rounded-md bg-primary px-[18px] text-sm font-semibold text-primary-foreground"
      >
        홈으로 돌아가기
      </Link>
    </main>
  );
}
